<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'PartnersHeader',
  inject: ['wp']
}
</script>
